var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-end mb-6"},[(_vm.contentFetched)?_c('DocsSideBar'):_vm._e(),_c('v-card',{staticClass:"scroll",attrs:{"flat":"","width":"80%","height":"100%"}},[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }